import React, { Suspense } from 'react';

import Placeholder from '../placeholder/Placeholder';

const FormattedDate = React.lazy(() => import('./FormattedDate'));

interface FormattedDateLazyProps {
  date: string;
  placeholderWidth?: string;
  placeholderHeight?: string;
}

export const FormattedDateLazy: React.FC<FormattedDateLazyProps> = ({
  date,
  placeholderWidth = '100%',
  placeholderHeight = '1em',
}) => {
  return (
    <Suspense fallback={<Placeholder width={placeholderWidth} height={placeholderHeight} />}>
      <FormattedDate date={date} />
    </Suspense>
  );
};
